import React from "react";
import { createRoot } from "react-dom/client";

import { Root } from "@apps/viewer/src/ts/components/Root";
import { urls } from "@apps/viewer/src/ts/config";
import { configure } from "mobx";
import { gGateway } from "@utils/gateway";
import { AutoAllowCookiesProvider } from "@provider/consent";
import { PM2NavigationProvider } from "./components/provider.navigation.client";
import { TanstackQueryProvider } from "@provider/tanstack";

import "@pm2/glossary-collection-component/styles.css";
import "@pm2/glossary-word/styles.css";
import "@pm2/react-utils/styles.css";
import "@pm2/ui-lightbox/styles.css";
import "@provider/print/styles.css";
import "@ui/css/styles.css";
import "@ui/kit/styles.css";
import "@utils/react/styles.css";

configure({
  enforceActions: "never",
});

gGateway.endpoint = "/viser/api/gateway";

/**
 * Render the application within the DOM.
 */

// Extract id of the currently selected course from the application
const courseId = window.location.pathname
  .replace(urls.basePath.replace(":courseId", ""), "")
  .split("/")[0];

const root = createRoot(document.getElementById("app")!);
root.render(
  <AutoAllowCookiesProvider>
    <TanstackQueryProvider>
      <PM2NavigationProvider>
        <Root courseId={courseId} />
      </PM2NavigationProvider>
    </TanstackQueryProvider>
  </AutoAllowCookiesProvider>,
);
